import type { AllApiKeys } from "../../ApiKey";
import { RichString } from "../../RichString";
import { SysadminRoleKey } from "../../SystemRoleKeys";
import { WorkspacePageType } from "../../WorkspacePageType";
import { ProblemSeverity } from "../ProblemSeverity";
import { createProblemFinder } from "../createProblemFinder";

export const ApiKeyProblems = createProblemFinder<AllApiKeys>(
  {
    roles: {
      length: {
        minimum: 1,
        message: (_value, _key, _validatorOptions, node) => `^${RichString.text(node.name)} must have a role assigned`,
        severity: ProblemSeverity.Error,
        inContextMessage: "^must have a role assigned",
      },
      excludesMember: {
        member: SysadminRoleKey,
        message: (_value, _key, _validatorOptions, node) => `^${RichString.text(node.name)} has unrestricted access to your app`,
        severity: ProblemSeverity.Warning,
        inContextMessage: "^has unrestricted access to your app",
      },
    },
  },
  { name: "API Key", tabType: WorkspacePageType.ApiKeys }
);
